import Vue from 'vue'
import Router from 'vue-router'
import register from "@/pages/auth/register";
import index from "@/pages/index/index";
import gonggao from "@/pages/index/gonggao";
import contact from "@/pages/index/contact";
import problem from "@/pages/index/problem";
import loginCode from "@/pages/auth/loginCode";
import login from "@/pages/auth/login";
import borrow from "@/pages/loanRecord/borrow/borrow";
import auth from "@/pages/auth/auth";
import home from "@/pages/home/home";
import editBascInfo from "@/pages/home/editBascInfo";
import service from "@/pages/home/service";
import my from "@/pages/home/my";
import setBanks from "@/pages/home/editInfos/setBanks";
import editPsd from "@/pages/auth/editPsd";
import addBanks from "@/pages/home/editInfos/addBanks";
import schedule from "@/pages/loanRecord/Audit/schedule";
import viewSchedule from "@/pages/loanRecord/Audit/viewSchedule";
import withdraw from "@/pages/loanRecord/withdraw/withdraw";
import repayLoan from "@/pages/loanRecord/repay/repayLoan";
import repayCenter from "@/pages/loanRecord/repay/repayCenter";
import repayView from "@/pages/loanRecord/repay/repayView";
import repayAccount from "@/pages/loanRecord/repay/repayAccount";
import photos from "@/pages/loanRecord/personInfo/photos";
import deal_photo from "@/pages/loanRecord/personInfo/deal_photo";
import face_intro from "@/pages/loanRecord/personInfo/face_intro";
import bascInfo from "@/pages/loanRecord/personInfo/bascInfo";
import Social from "@/pages/loanRecord/personInfo/Social";
import banks from "@/pages/loanRecord/personInfo/banks";
import yys from "@/pages/loanRecord/personInfo/yys/yys";
import yys_send from "@/pages/loanRecord/personInfo/yys/yys_send";
import chooseYYS from "@/pages/loanRecord/personInfo/yys/chooseYYS";
import auth_succ from "@/pages/loanRecord/personInfo/auth_succ";
Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};



export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/gonggao',
      name: 'gonggao',
      component: gonggao
    },
    {
      path: '/auth',
      name: 'auth',
      component: auth,
      redirect:'/auth/register',//路由重定向，自动转到‘/auth/register’下
      children:[{
        path: 'register',
        name: 'register',
        component: register
      },
        {
          path: 'loginCode',
          name: 'loginCode',
          component: loginCode
        }
      ]
    },
    {
      path: '/home',
      name: 'home',
      component: home,
      redirect:'/home/editBascInfo',
      children:[{
        path: 'editBascInfo',
        name: 'editBascInfo',
        component: editBascInfo
      },
        {
          path: 'my',
          name: 'my',
          component: my
        }
      ]
    },
    {
      path: '/schedule',
      name: 'schedule',
      component: schedule
    },
    {
      path: '/auth/login',
      name: 'login',
      component: login
    },
    {
      path: '/schedule/viewSchedule',
      name: 'viewSchedule',
      component: viewSchedule
    },
    {
      path: '/schedule/withdraw',
      name: 'withdraw',
      component: withdraw
    },
    {
      path: '/schedule/repay',
      name: 'repayLoan',
      component: repayLoan
    },
    {
      path: '/schedule/repay/repayCenter',
      name: 'repayCenter',
      component: repayCenter
    },
    {
      path: '/schedule/repay/repayAccount',
      name: 'repayAccount',
      component: repayAccount
    },
    {
      path: '/photos',
      name: 'photos',
      component: photos
    },
    {
      path: '/face_intro',
      name: 'face_intro',
      component: face_intro
    },
    {
      path: '/photos/dealPhoto',
      name: 'deal_photo',
      component: deal_photo
    },
    {
      path: '/bascInfo',
      name: 'bascInfo',
      component: bascInfo
    },
    {
      path: '/Social',
      name: 'Social',
      component: Social
    },
    {
      path: '/banks',
      name: 'banks',
      component: banks
    },
    {
      path: '/yys',
      name: 'yys',
      component: yys
    },
    {
      path: '/yys_send',
      name: 'yys_send',
      component: yys_send
    },
    {
      path: '/chooseYYS',
      name: 'chooseYYS',
      component: chooseYYS
    },
    {
      path: '/auth_succ',
      name: 'auth_succ',
      component: auth_succ
    },
    {
      path: '/home/my/setBanks',
      name: 'setBanks',
      component: setBanks
    },
    {
      path: '/home/my/setBanks/addBanks',
      name: 'addBanks',
      component: addBanks
    },
    {
      path: '/home/my/service',
      name: 'service',
      component: service
    },
    {
      path: '/borrow',
      name: 'borrow',
      component: borrow
    },
    {
      path: '/editPsd',
      name: 'editPsd',
      component: editPsd
    },
    {
      path: '/ContactUS',
      name: 'contact',
      component: contact
    },
    {
      path: '/problem',
      name: 'problem',
      component: problem
    },
    {
      path: '/repayView',
      name: 'repayView',
      component: repayView
    },
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js